module.exports = __webpack_public_path__ + "img/ro2.6890a143.jpg";